<template>
    <div class="input-container checked-client">
        <label class="client-name" :class="{beforeChecked: isChecked}">
            <input v-model="value"
                   :disabled="disabled || !isEditable"
                   type="text"
                   autocomplete="off"
                   @click="customFocus"
                   @blur="isEdited = true"
                   @input="isEdited = true"
                   :name="name"/>
            <span :class="{incorrect: validate && isEdited, beforeVisit : !isVisited, correct: !isChecked}"
                  class="custom_placeholder"
                  v-html="placeholder">

            </span>
        </label>
        <label class="default-client checkbox">{{translate('default')}}
            <input type="checkbox"
                   @change="customChecked"
                   :checked="isChecked"
                    :disabled="!isEditable">
            <span class="checkmark"/>
        </label>
        <span class="error-display"
              v-if="validate && isEdited"
              :class="{hidden_msg: !isChecked}"
              v-html="translate(errorMsg)">
        </span>
    </div>
</template>

<script>
    export default {
        name: "inputClient",
        props: ['placeholder', 'dataType', 'regex', 'require', 'name'],
        data() {
            return {
                value: '',
                isEdited: false,
                isVisited: false,
                isChecked: true,
                errorMsg: 'error_msg_empty_field',
                disabled: true,
                type: ''
            }
        },

        methods: {

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            customFocus() {
                if(!this.isEditable) {
                    return;
                }
                this.isChecked = false;
                this.disabled = false;
                this.isEdited = false;
                this.isVisited = true;
            },

            customChecked() {
                if(!this.isEditable) {
                    return;
                }
                this.isChecked = !this.isChecked;
                if(this.isChecked){
                    this.value = '';
                    this.disabled = true;
                    this.isEdited = false;
                    this.isVisited = false;
                } else {
                    this.disabled = false;
                    this.isEdited = false;
                    this.isVisited = true;
                }
            },

            emitValidateData() {

                if (!this.isChecked) {

                    this.customFocus();
                    this.isEdited = true;

                    this.$parent.$emit('validateData', {
                        title: this.name,
                        isIncorect: this.validate,
                        value: this.validate ? '' : this.value,
                    });
                }
            },
        },

        computed: {
            validate() {

                if (this.require) {
                    if (this.regex) {
                        return !this.regex.test(this.value);
                    } else {
                        return this.value === '';
                    }
                } else {
                    return false;
                }
            },

            isEditable() {
                return this.$store.getters.isOfferEditable;
            }
        },

        mounted() {
            this.$parent.$on('getValidateData', () => {
                this.emitValidateData();
            });
        },

        created() {
            if (this.$store.state.productCard.custom.summary_form[this.name] !== undefined) {
                if(this.$store.state.productCard.custom.summary_form[this.name].value !== (undefined || null)) {
                    this.value = this.$store.state.productCard.custom.summary_form[this.name].value;
                    this.isEdited = false;
                    this.disabled = false;
                    this.isChecked = false;
                    this.isVisited = true;
                }
            }
        }
    }
</script>